import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import withMessages from '../../utilities/intl';

import SortDropdownValues from './SortDropdownValues.json';
import styles from './splitview.scss';

const BASE_KEY = 'components.split_view.sort';

const {
    NEWEST_TO_OLDEST,
    OLDEST_TO_NEWEST,
    SENDER_ASC,
    SENDER_DESC,
    ATTACHMENTS_COUNT,
} = SortDropdownValues;

function SplitViewSortActionComponent({ getMessage, activeValue, onSelect, disabled }) {
    function renderList() {
        return [
            NEWEST_TO_OLDEST, OLDEST_TO_NEWEST, SENDER_ASC, SENDER_DESC, ATTACHMENTS_COUNT,
        ].map((dropdownValue) => {
            const wrapperClass =
        `dropdown-item-${activeValue === dropdownValue ? 'active' : 'normal'}`;

            return (
                <span
                    role="presentation"
                    key={dropdownValue}
                    className={styles[wrapperClass]}
                    onClick={() => onSelect(dropdownValue)}
                >
                    {getMessage(`${BASE_KEY}.${dropdownValue}`)}
                </span>
            );
        });
    }

    return (
        <span className={styles['splitview-list-sort']} data-action="sort-dropdown">
            <span className={styles.dropdown}>
                <span className={styles[`dropdown-title${disabled ? '-disabled' : '-normal'}`]}>
                    {getMessage(`${BASE_KEY}.sort`)}
                </span>
                <span className={styles['dropdown-arrow']} />
                {!disabled && (
                    <span className={styles['dropdown-box']}>
                        <span className={styles['dropdown-menu-white']}>
                            {renderList()}
                        </span>
                    </span>
                )}
            </span>
        </span>
    );
}

SplitViewSortActionComponent.propTypes = {
    getMessage: PropTypes.func,
    activeValue: PropTypes.string,
    onSelect: PropTypes.func,
    disabled: PropTypes.bool.isRequired,
};

SplitViewSortActionComponent.defaultProps = {
    getMessage: () => {},
    activeValue: '',
    onSelect: () => {},
};

const SplitViewSortAction = withMessages(SplitViewSortActionComponent);
SplitViewSortAction.displayName = displayName('SplitView/SplitViewSortAction');

export default SplitViewSortAction;
